import { render, staticRenderFns } from "./edit_detail_work.vue?vue&type=template&id=680852c9&"
import script from "./edit_detail_work.vue?vue&type=script&lang=js&"
export * from "./edit_detail_work.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports